import React, { useRef, useEffect } from "react";
import Box from "@mui/material/Box";
import clsx from "clsx";
import { useStyles } from "./featuredProductStyles";
import { IFeaturedProduct } from "./IFeaturedProduct";
import {
    aniFeaturedProduct,
    aniFeaturedProductKill,
} from "./featuredAnimation";

import favorite_svg from "../../assets/images/favorite.svg";
import { Button } from "@mui/material";

const FeaturedProduct = ({
    variant,
    sku,
    description,
    backgroundImage,
    attributes,
    isHero,
    tagline,
    isFullBackground,
    id,
}: IFeaturedProduct) => {
    const root = useRef(null);

    const { classes } = useStyles({
        backgroundImage: `${backgroundImage}`,
    });

    const productClass = isHero ? "hero" : "featured";
    const withBackgroundClass =
        backgroundImage && isFullBackground ? "with-background" : null;
    const imageContainerClass = isFullBackground ? null : "with-background";

    const productImageSrc = attributes?.image;
    const infoContainerClass =
        backgroundImage && isFullBackground ? "full-background" : null;

    useEffect(() => {
        root && aniFeaturedProduct(root);

        return () => {
            root && aniFeaturedProductKill(root);
        };
    }, []);

    return (
        <Box className={classes.outer} id={isHero ? "hero" : ""}>
            <Box
                id={id}
                data-name="FeaturedProduct"
                ref={root}
                className={clsx([
                    classes.root,
                    variant,
                    withBackgroundClass,
                    productClass,
                    "root",
                ])}
            >
                <Box
                    className={clsx([
                        classes.imageContainer,
                        imageContainerClass,
                    ])}
                >
                    <img src={productImageSrc} alt={attributes?.name} />
                </Box>
                <Box
                    className={clsx([
                        classes.infoContainer,
                        infoContainerClass,
                        productClass,
                    ])}
                >
                    <Box className={classes.infoDescription}>
                        <span id="tagline" className="product-tagline">
                            {tagline}
                        </span>
                        <span className="product-description">
                            {description}
                        </span>
                    </Box>

                    <Box className={classes.infoCommercial}>
                        <span className="product-eyebrow">
                            {attributes?.collection}
                        </span>
                        <div className="product-name-price">
                            <span className="product-name">
                                {attributes?.name}
                            </span>
                            <hr />
                            <span className="product-price">
                                {attributes?.price}
                            </span>
                        </div>
                    </Box>
                    <Box className={classes.infoCta}>
                        {isHero && (
                            <Button className="cta-button" onClick={() => {}}>
                                Add to Cart
                            </Button>
                        )}
                        <span className="cta-link">
                            {isHero ? "Enquire" : "Learn More"}
                        </span>
                    </Box>
                    <div className="favorite-icon">
                        <img src={favorite_svg} alt="Save in favorites" />
                    </div>
                </Box>
            </Box>
        </Box>
    );
};

export default FeaturedProduct;
